// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import * as filters from '@/script/tools/filter'  //过滤器
import qs from 'qs'
import store from '@/script/store'   //状态管理器
import { get, post, postObject, uploadImg } from '@/script/request/http'     //配置网络请求     //旧vue-resource
import { } from '@/script/maketime/time' //适配设备状态
import router from '@/router'   //配置路由
import { Decrypt, Encrypt } from '@/script/tools/aes' //加密
// import Message from '@/message/' //全局信息组件
import '@/css/media.less'   //媒体样式
import '@/css/style.css'   //图标
import Vue from 'vue' //入口文件
import OOPVR from '@/OOPVR'
import { Button,Icon,Row,Col,Layout,Space,Breadcrumb,Dropdown,Menu,PageHeader,Pagination,Steps,Cascader,
  Checkbox,DatePicker,Form,FormModel,Input,InputNumber,Mentions,Radio,Rate,Select,Switch,TimePicker,TreeSelect,
  Upload,Avatar,Badge,Calendar,Card,Carousel,Collapse,Comment,Empty,List,Popover,Statistic,Table,Tabs,Tag,Tooltip,
  Tree,Alert,Drawer,Modal,Popconfirm,Skeleton,Progress,message, Descriptions,Spin } from 'ant-design-vue'
  Vue.use(Row)
  Vue.use(Col)
  Vue.use(Layout)
  Vue.use(Space)
  Vue.use(Card)
  Vue.use(Menu)
  Vue.use(Breadcrumb)
  Vue.use(Descriptions)
  Vue.use(List)
  Vue.use(Form)
  Vue.use(FormModel)
  Vue.use(Input)
  Vue.use(InputNumber)
  Vue.use(Upload)
  Vue.use(Radio)
  Vue.use(Progress)
  Vue.use(Modal)
  Vue.use(Popover)
  Vue.use(Avatar)
  Vue.use(Icon)
  Vue.use(Carousel)
  Vue.use(Tabs)
  Vue.use(Popconfirm)
  Vue.use(Dropdown)
  Vue.use(PageHeader)
  Vue.use(Pagination)
  Vue.use(Steps)
  Vue.use(Cascader)
  Vue.use(Checkbox)
  Vue.use(DatePicker)
  Vue.use(Mentions)
  Vue.use(Rate)
  Vue.use(Select)
  Vue.use(Switch)
  Vue.use(TimePicker)
  Vue.use(TreeSelect)
  Vue.use(Badge)
  Vue.use(Calendar)
  Vue.use(Collapse)
  Vue.use(Comment)
  Vue.use(Empty)
  Vue.use(Statistic)
  Vue.use(Table)
  Vue.use(Tag)
  Vue.use(Tooltip)
  Vue.use(Tree)
  Vue.use(Alert)
  Vue.use(Drawer)
  Vue.use(Skeleton)
  Vue.use(Button)
  Vue.use(Spin)


function initOrTempKey() {
  if (JSON.parse(localStorage.getItem('vuex-netUser')).netuser !=null) {
    let date = new Date();
    console.log('oopvrClient' + date.valueOf())
    store.commit("setOrTempKey", 'oopvrClient' + date.valueOf())
  }
}

initOrTempKey();

Object.keys(filters).forEach( //注册过滤器
  key => {
    Vue.filter(key, filters[key])
  }
)
Vue.prototype.$message = message
// Vue.prototype.$my_message = Message.install; //定义全局信息组件
Vue.prototype.$get = get;
Vue.prototype.$post = post;
Vue.prototype.$postObject = postObject;
Vue.prototype.$Decrypt = Decrypt;
Vue.prototype.$Encrypt = Encrypt;
Vue.prototype.$qs = qs;
// Vue.prototype.$host = 'http://localhost:5555';
Vue.prototype.$host = 'https://api.oopvr.com:8080';
Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#OOPVR',
  router,
  store,
  components: { OOPVR },
  template: '<OOPVR/>',
})

Vue.prototype.backBefor = () => {
  window.history.back(-1)
}
Vue.prototype.$arrUnique = (arr, key) => {
  let returnArr = [];
  if (key) {
    // 对象数组去重
    const obj = {};
    returnArr = arr.reduce((cur, next) => {
      obj[next[key]] ? '' : obj[next[key]] = true && cur.push(next);
      return cur;
    }, []);
    return returnArr;
  }
  // 普通数组去重
  returnArr = arr.reduce((cur, next) => {
    !cur.includes(next) && cur.push(next);
    return cur;
  }, []);
  return returnArr;
}

router.afterEach(() => {//路由每次切换，滚动条滚动值0
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;

})


// //获取浏览器缩放比例
// function ChangeRatio() {
//   var ratio = 0;
//   var screen = window.screen;
//   var ua = navigator.userAgent.toLowerCase();

//   if (window.devicePixelRatio !== undefined) {
//     ratio = window.devicePixelRatio;
//   }
//   else if (~ua.indexOf('msie')) {
//     if (screen.deviceXDPI && screen.logicalXDPI) {
//       ratio = screen.deviceXDPI / screen.logicalXDPI;
//     }

//   }
//   else if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
//     ratio = window.outerWidth / window.innerWidth;
//   }

//   if (ratio) {
//     ratio = Math.round(ratio * 100);
//   }
//   return ratio;
// }


// //监听浏览器变化
// window.onresize = function () {
//   initWindowSize();
// };

// //进行比例缩放
// function setAppScale(ratio) {
//   let ratioX = (100 / ratio);
//   let ratioY = (100 / ratio);
//   const css0 = document.styleSheets[0];
//   css0.insertRule("body { transform: scale( "+ratioX+","+ratioY+"); transformOrigin: left top}", css0.rules.length);
// }


// function initWindowSize() {
//   var ratio = ChangeRatio();
//   console.log(ratio);
//   setAppScale(ratio);
// }

// initWindowSize();



// console.log(window.localStorage)


// WEBPACK FOOTER //
// ./src/main.js